import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './failed/failed.component';
import { InfoComponent } from './info/info.component';
import { HomeComponent } from './home/home.component';
import { FormsListComponent } from './forms/forms-list/forms-list.component';
import { PreviewFormComponent } from './forms/preview-form/preview-form.component';
import { SaveFormComponent } from './forms/save-form/save-form.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { LetterTemplateComponent } from './letter-template/letter-template.component';
import { TextMessageTemplateComponent } from './text-message-template/text-message-template.component';
import { QuestionGroupsListComponent } from "./question-groups/question-groups-list/question-groups-list.component";

export const routes: Routes = [
  {
    path: "",
    component: HomeComponent
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: "app-info",
    component: InfoComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },
  {
    path: 'forms',
    component: FormsListComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'forms/preview/:id',
    component: PreviewFormComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'forms/edit/:id',
    component: SaveFormComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'forms/create',
    component: SaveFormComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'question-groups',
    component: QuestionGroupsListComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'email',
    component: EmailTemplateComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'letter',
    component: LetterTemplateComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'text',
    component: TextMessageTemplateComponent,
    canActivate: [MsalGuard]
  }
];
